module.exports = '<svg width="18" height="32" viewBox="0 0 18 32"><path d="M16.077.282l-8.079 7.76H2c-1.106 0-1.999.924-1.999 2.007v11.9c0 1.084.894 2.087 1.999 2.087h5.998l8.121 7.786s1.875 1.1 1.875-2.153V2.204c0-3.289-1.917-1.921-1.917-1.921z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/speaker-4.js
// module id = 1430
// module chunks = 14